<template>
  <div
    v-if="priority"
    class="inline-flex items-center font-extrabold"
  >
    <font-awesome-icon icon="fa-solid fa-chevrons-up" v-if="priorityLowercase === 'critical'" class="w-4 h-4 text-red-600 dark:text-red-400" />
    <font-awesome-icon icon="fa-solid fa-grip-lines" v-if="priorityLowercase === 'medium'" class="w-4 h-4 text-yellow-500 dark:text-yellow-400" />
    <font-awesome-icon icon="fa-solid fa-chevrons-down" v-if="priorityLowercase === 'low'" class="w-4 h-4 text-green-500 dark:text-green-400" />
    <font-awesome-icon icon="fa-solid fa-check" v-if="priorityLowercase === 'all'" class="w-4 h-4 text-gray-500 dark:text-gray-400" />
  </div>
</template>

<script>
export default {
  name: "PriorityChip",
  props: {
    priority: {
      type: String,
      required: false
    }
  },
  computed: {
    priorityLowercase() {
      return this.priority.toLowerCase()
    }
  }
}
</script>